/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { ChangeEvent, FC, useEffect, useState, useRef } from 'react';
import { styled } from 'linaria/react';
import { Text, Spinner } from '@shared/ui/atoms';
import { withTheme } from '@shared/lib/theme';
const keyCodeMapping = {
  backspace: 8,
  left: 37,
  right: 39
};
const resetTimeout = 3000;
const getInitialState = (values: Array<string>, fieldsCount: number) => {
  const initialArray = Array(fieldsCount).fill('');
  if (!values || values.length === 0) {
    return initialArray;
  }
  return initialArray.map((arrayItem, index) => values[index] || arrayItem);
};
export interface ConfirmationFieldInputsProps {
  onChange: (value: string) => void;
  onComplete: (value: string, showErr: (text: string) => void) => void;
  fieldsCount: number;
  isErrorAutoClearEnabled: boolean;
  isLoading: boolean;
  fieldWidth: number;
  fieldHeight: number;
  initialValues: Array<string>;
  isDisabled: boolean;
  type: string;
  autoFocus: boolean;
  autoComplete?: string;
  variant?: 'default' | 'premiumBanking';
  bgLayer?: boolean;
  hasError?: boolean;
  errorMessage?: string;
}
export const ConfirmationFieldInputs: FC<Partial<ConfirmationFieldInputsProps>> = ({
  initialValues,
  fieldsCount = 0,
  fieldWidth,
  fieldHeight,
  isErrorAutoClearEnabled,
  isLoading,
  onChange,
  onComplete,
  isDisabled,
  type,
  autoFocus,
  autoComplete,
  hasError,
  errorMessage
}) => {
  const [inputValues, setInputValues] = useState(getInitialState(initialValues as string[], fieldsCount));
  const [errorText, setErrorText] = useState('');
  const [completed, setCompleted] = useState(false);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  useEffect(() => {
    inputRefs.current = inputRefs.current.slice(0, fieldsCount);
    while (inputRefs.current.length < fieldsCount) {
      inputRefs.current.push(null);
    }
  }, [fieldsCount]);
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    inputValues.every(val => val === '') ? inputRefs.current[0]?.focus() : e.target.select();
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, refIndex: number) => {
    const prevInputRef = inputRefs.current[refIndex - 1];
    const nextInputRef = inputRefs.current[refIndex + 1];
    switch (e.keyCode) {
      case keyCodeMapping.backspace:
        {
          e.preventDefault();
          if (inputValues[refIndex]) {
            setInputValues(prev => {
              const newValues = [...prev];
              newValues[refIndex] = '';
              return newValues;
            });
          } else if (prevInputRef) {
            setInputValues(prev => {
              const newValues = [...prev];
              newValues[refIndex - 1] = '';
              return newValues;
            });
            prevInputRef.focus();
          }
          break;
        }
      case keyCodeMapping.left:
        e.preventDefault();
        if (prevInputRef) {
          prevInputRef.focus();
        }
        break;
      case keyCodeMapping.right:
        e.preventDefault();
        if (nextInputRef) {
          nextInputRef.focus();
        }
        break;
      default:
        break;
    }
  };
  const handleChange = (e: ChangeEvent<HTMLInputElement>, refIndex: number) => {
    if (errorText) {
      setErrorText('');
    }
    let {
      value
    } = e.target;
    if (type === 'number') {
      value = value.replace(/[^\d]/gi, '');
    }
    if (value === '' || type === 'number' && !e.target.validity.valid) {
      return;
    }
    setInputValues(prev => {
      const newValues = [...prev];
      const chars = value.split('');
      chars.forEach((char, i) => {
        if (refIndex + i < fieldsCount) {
          newValues[refIndex + i] = char;
        }
      });
      return newValues.slice(0, fieldsCount);
    });
    const nextIndex = Math.min(refIndex + value.length, fieldsCount - 1);
    if (nextIndex > refIndex) {
      setTimeout(() => {
        inputRefs.current[nextIndex]?.focus();
      }, 0);
    }
  };
  useEffect(() => {
    const value = inputValues.join('');
    onChange && onChange(value);
    if (onComplete && value.length === fieldsCount && !completed) {
      const showErr = (text: string) => {
        setErrorText(text);
      };
      onComplete(value, showErr);
    }
    if (value.length < fieldsCount && errorText) {
      setErrorText('');
    }
  }, [inputValues, completed, fieldsCount, onChange, onComplete]);
  useEffect(() => {
    const value = inputValues.join('');
    setCompleted(value.length === fieldsCount);
  }, [inputValues, fieldsCount]);
  useEffect(() => {
    let timerId: NodeJS.Timeout | undefined;
    if (errorText && isErrorAutoClearEnabled) {
      timerId = setTimeout(() => {
        const emptyValuesArray = Array(fieldsCount).fill('');
        setErrorText('');
        setInputValues(emptyValuesArray);
        setTimeout(() => {
          inputRefs.current[0]?.focus();
        }, 0);
      }, resetTimeout);
    }
    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [errorText, isErrorAutoClearEnabled, fieldsCount]);
  useEffect(() => {
    if ('OTPCredential' in window && navigator.credentials) {
      const ac = new AbortController();
      navigator.credentials.get({
        otp: {
          transport: ['sms']
        },
        signal: ac.signal
      } as CredentialRequestOptions & {
        otp: {
          transport: Array<string>;
        };
      }).then((otp: Credential & {
        code: string;
        type: 'otp';
      }) => {
        const otpChars = otp.code.split('').slice(0, fieldsCount);
        setInputValues(prev => {
          const newValues = [...prev];
          otpChars.forEach((char, idx) => {
            newValues[idx] = char;
          });
          return newValues;
        });
        setTimeout(() => {
          const focusIndex = Math.min(otpChars.length, fieldsCount - 1);
          inputRefs.current[focusIndex]?.focus();
        }, 0);
      }).catch(err => {
        if (!ac.signal.aborted) console.error(err);
      });
      return () => {
        ac.abort();
      };
    }
  }, [fieldsCount]);
  useEffect(() => {
    if (autoFocus && inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, [autoFocus]);
  return <OuterWrapper hasError={errorText.length > 0 || Boolean(hasError)}>
      <Wrapper>
        <div>
          {inputValues.map((value, index) => <Input key={index} value={value} ref={el => {
          inputRefs.current[index] = el;
        }} onChange={event => handleChange(event, index)} onKeyDown={event => handleKeyDown(event, index)} onFocus={handleFocus} fieldWidth={fieldWidth as number} fieldHeight={fieldHeight as number} disabled={isDisabled} inputMode="numeric" autoFocus={!!(autoFocus && index === 0)} autoComplete={autoComplete} />)}
        </div>
        {(errorText || hasError) && <Text family="MTSCompact" size="captionL" weight="medium" color="negative">
            {errorText || errorMessage}
          </Text>}
      </Wrapper>
      {isLoading && <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>}
    </OuterWrapper>;
};
interface OuterWrapperProps {
  hasError: boolean;
}
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.tertiary;
const _exp4 = /*#__PURE__*/() => ({
  hasError,
  theme
}) => hasError ? theme.colors.stroke.error : theme.colors.stroke.default;
const _exp5 = /*#__PURE__*/() => ({
  hasError,
  theme
}) => hasError ? theme.colors.stroke.error : theme.colors.stroke.active;
const OuterWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "OuterWrapper",
  class: "o3cmwre",
  propsAsIs: false,
  vars: {
    "o3cmwre-0": [_exp2()],
    "o3cmwre-1": [_exp3()],
    "o3cmwre-2": [_exp4()],
    "o3cmwre-3": [_exp5()]
  }
}));
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wg3hfti",
  propsAsIs: false
});
interface InputProps {
  fieldWidth: number;
  fieldHeight: number;
}
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.family.MTSCompact;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.size.rem.pL;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.lineHeight.rem.pL;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.letterSpacing.rem.pL;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.weight.medium;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.size.px.pL;
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.lineHeight.px.pL;
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.letterSpacing.px.pL;
const Input = withTheme(/*#__PURE__*/styled('input')({
  name: "Input",
  class: "i1v4f19i",
  propsAsIs: false,
  vars: {
    "i1v4f19i-0": [_exp6()],
    "i1v4f19i-1": [_exp7()],
    "i1v4f19i-2": [_exp8()],
    "i1v4f19i-3": [_exp9()],
    "i1v4f19i-4": [_exp0()],
    "i1v4f19i-5": [_exp1()],
    "i1v4f19i-6": [_exp10()],
    "i1v4f19i-7": [_exp11()],
    "i1v4f19i-8": [_exp12()]
  }
}));
const SpinnerContainer = /*#__PURE__*/styled('div')({
  name: "SpinnerContainer",
  class: "s1qwckxr",
  propsAsIs: false
});

require("./ConfirmationFieldInputs.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ConfirmationFieldInputs.tsx");